import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Sparkles } from "lucide-react";
import HoverTooltip from "../../../common_components/hoverOverlay/HoverTooltip";
const GRADIENT = "linear-gradient(135deg, #FF008E 0%, #FF5CB8 100%)";
const REDUCED = "@media (prefers-reduced-motion: reduce)";
const AskAiButton = ({ onClick, disabled = false, disabledReason }) => (_jsx(HoverTooltip, { title: disabled ? disabledReason || "" : "Describe the report and let the G8A AI Agent build the selection", placement: "top", children: _jsx(Box, { role: "button", "aria-label": "G8A AI Agent - build this report", "aria-disabled": disabled, tabIndex: disabled ? -1 : 0, onClick: () => !disabled && onClick(), onKeyDown: (e) => {
            if (!disabled && (e.key === "Enter" || e.key === " ")) {
                e.preventDefault();
                onClick();
            }
        }, sx: {
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            height: 36,
            px: 1.75,
            flexShrink: 0,
            borderRadius: "8px",
            border: "1px solid transparent",
            overflow: "hidden",
            // Gradient border on a white fill: two backgrounds clipped to
            // padding-box and border-box.
            background: `linear-gradient(#fff, #fff) padding-box, ${GRADIENT} border-box`,
            color: "#E6007A",
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.5 : 1,
            whiteSpace: "nowrap",
            transition: "background .2s ease, box-shadow .2s ease, transform .15s ease",
            "@keyframes askAiBtnTwinkle": {
                "0%, 100%": { transform: "scale(1) rotate(0deg)", opacity: 1 },
                "50%": { transform: "scale(1.18) rotate(14deg)", opacity: 0.8 },
            },
            "@keyframes askAiBtnSweep": {
                from: { transform: "translateX(-150%) skewX(-20deg)" },
                to: { transform: "translateX(350%) skewX(-20deg)" },
            },
            "& svg": {
                animation: disabled ? "none" : "askAiBtnTwinkle 2.8s ease-in-out infinite",
                [REDUCED]: { animation: "none" },
            },
            // The sweep: hidden off to the left until hover.
            "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                width: "35%",
                background: "linear-gradient(90deg, transparent, rgba(255,0,142,0.18), transparent)",
                transform: "translateX(-150%) skewX(-20deg)",
                pointerEvents: "none",
            },
            "&:hover": disabled
                ? undefined
                : {
                    background: `linear-gradient(#FFFAFD, #FFFAFD) padding-box, ${GRADIENT} border-box`,
                    boxShadow: "0 0 0 3px rgba(255,0,142,0.12), 0 6px 14px -8px rgba(255,0,142,0.6)",
                    transform: "translateY(-1px)",
                    "&::after": {
                        animation: "askAiBtnSweep 0.8s ease-out",
                        [REDUCED]: { animation: "none" },
                    },
                },
            "&:active": disabled ? undefined : { transform: "translateY(0)" },
            "&:focus-visible": { outline: "none", boxShadow: "0 0 0 3px rgba(255,0,142,0.25)" },
            [REDUCED]: { transition: "none" },
        }, children: _jsx(Sparkles, { size: 16 }) }) }));
export default AskAiButton;
